import restCrudActions from '../../../np-crud/store/restCrudActions'
import { snackActions } from '../../../sc-utilities/SnackBar';
import { getAxiosInstance } from '../../../np-rest/rest';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: '/billing/plan',
    pluginName: 'BILLING',
    entityName: 'PLAN',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch billingPlan action creators
export const fetchBillingPlanInit = () => {
    return crudActions.fetchInit();
};
export const fetchBillingPlanStart = () => {
    return crudActions.fetchStart();
};
export const fetchBillingPlanSuccess = (fetchBillingPlanCount, listBillingPlanCount) => {
    return crudActions.fetchSuccess(fetchBillingPlanCount, listBillingPlanCount);
};
export const fetchBillingPlanFail = () => {
    return crudActions.fetchFail();
};
export const fetchBillingPlan = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchBillingPlanStart());
        try {
            let countRes = await rest.post("/plan/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                let listRes = await rest.post("/plan/list", filterData);
                if (listRes.data && listRes.data.succeeded) {
                    dispatch(fetchBillingPlanSuccess(countRes.data.result.data, listRes.data.result.data));
                    return { data: listRes.data.result.data, count: countRes.data.result.data }
                }
            }
            dispatch(fetchBillingPlanFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch billing plans."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: [], count: 0 };
        } catch (error) {
            dispatch(fetchBillingPlanFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch billing plans."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: [], count: 0 }
        }
    }
}

// Load billingPlan action creators
export const loadBillingPlanInit = () => {
    return crudActions.loadInit();
};
export const loadBillingPlanStart = () => {
    return crudActions.loadStart();
};
export const loadBillingPlanSuccess = loadedBillingPlan => {
    return crudActions.loadSuccess(loadedBillingPlan);
};
export const loadBillingPlanFail = error => {
    return crudActions.loadFail(error);
};
export const loadBillingPlan = id => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(loadBillingPlanStart());
            let res = await rest.post('/plan/load', id);
            if (res.data && res.data.succeeded) {
                dispatch(loadBillingPlanSuccess(res?.data?.result?.data));
                return { data: res.data.result.data, count: 0 }
            }
            else {
                dispatch(loadBillingPlanFail());

                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return {};
            }
        } catch (error) {
            dispatch(loadBillingPlanFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};

// Create billingPlan  action creators
export const createBillingPlanInit = () => {
    return crudActions.createInit();
};
export const createBillingPlanStart = () => {
    return crudActions.createStart();
};
export const createBillingPlanSuccess = createdBillingPlan => {
    return crudActions.createSuccess(createdBillingPlan);
};
export const createBillingPlanFail = error => {
    return crudActions.createFail(error);
};
export const createBillingPlan = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createBillingPlanStart());
        try {
            let res = await rest.post('/plan/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created top up.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createBillingPlanFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create top up."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create top up."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createBillingPlanFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Edit billing plan action creators
export const editBillingPlanInit = () => {
    return crudActions.editInit();
};
export const editBillingPlanStart = () => {
    return crudActions.editStart();
};
export const editBillingPlanSuccess = BillingPlan => {
    return crudActions.editSuccess(BillingPlan);
};
export const editBillingPlanFail = error => {
    return crudActions.editFail(error);
};
export const editBillingPlan = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editBillingPlanStart());
        try {
            let res = await rest.post('/plan/update', params);
            if (res.data && res.data.succeeded) {
                dispatch(editBillingPlanSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated billing plan.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editBillingPlanFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit billing plan."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit billing plan."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editBillingPlanFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Edit price list action creators
export const editPriceListInit = () => {
    return crudActions.editInit();
};
export const editPriceListStart = () => {
    return crudActions.editStart();
};
export const editPriceListSuccess = PriceList => {
    return crudActions.editSuccess(PriceList);
};
export const editPriceListFail = error => {
    return crudActions.editFail(error);
};
export const editPriceList = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editPriceListStart());
        try {
            let res = await rest.post('/billing/plan/save-price-list', params);
            if (res.data && res.data.succeeded) {
                dispatch(editPriceListSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated price list.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editPriceListFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit price list."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit price list."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editPriceListFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete billingPlan action creators
export const bulkDeleteBillingPlansInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteBillingPlansStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteBillingPlansSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteBillingPlansFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteBillingPlans = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteBillingPlansStart());
        try {
            let res = await rest.post('/plan/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteBillingPlansSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted billing plans.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteBillingPlansFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete billing plans."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete billing plans."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteBillingPlansFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Delete billingPlan  action creators
export const deleteBillingPlanInit = () => {
    return crudActions.deleteInit();
};
export const deleteBillingPlanStart = () => {
    return crudActions.deleteStart();
};
export const deleteBillingPlanSuccess = deletedBillingPlan => {
    return crudActions.deleteSuccess(deletedBillingPlan);
};
export const deleteBillingPlanFail = error => {
    return crudActions.deleteFail(error);
};
export const deleteBillingPlan = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};